export const locale = {
    WEEKDAYS: {
        MONDAY: "星期一",
        TUESDAY: "星期二",
        WEDNESDAY: "星期三",
        THURSDAY: "星期四",
        FRIDAY: "星期五",
        SATURDAY: "星期六",
        SUNDAY: "星期日",
    },
    COMMON: {
        LBL_AGENT: "GBizs 代理",
        LBL_MOBILE_CONTACT_NO: "手机联系号",
        LBL_MOBILE_CONTTACT_PIC: "手机联系人",
        LBL_ALT_MOBILE_CONTACT_NO: "手机联系号 (外加)",
        LBL_ALT_MOBILE_CONTTACT_PIC: "手机联系人 (外加)",
        LBL_STATUS: "状态",

        LBL_OFFICE_NO: "办公室联络号 ",
        LBL_OFFICE_NO_PIC: "办公室联络人",
        LBL_SET_INVALID_PERSONNEL: "Invalid By",
        LBL_APPROVED_BY: "Approved By",
        LBL_REJECTED_BY: "Rejected By",
        LBL_REVERTED_BY: "Reverted By",
        LBL_ACKNOWLEDGE_BY: "Acknowledge By",
        LBL_VERIFY_BY: "Verify By",
        LBL_ACTION_TIME: "Action Time",
        LBL_REFERENCE_NO: "单号",
        LBL_HISTORY_DATE: "修改日期",
        LBL_PARCEL_GUARANTEE: "货物保障",
        LBL_REMARK: "备注",
        LBL_ACTION: "功能",
        LBL_AR_REMARK: "AR 备注",
        LBL_AP_REMARK: "AP 备注",
        LBL_RECEIVED_AMOUNT: "收货金额",
        LBL_RECEIVED_DATE: "收货日期",
        LBL_MARKING: "客户代号",
        LBL_SO_NO: "S/O No.",
        LBL_NOTICE_TYPE: "Notice Type",
        LBL_EMAIL: "邮址",
        LBL_TIN_NO: "Tin No.",
        LBL_ENABLE_SST: "Enable SST",
        LBL_ENABLE_EINV: "Enable E-Invoice",
        LBL_EINV_EN_DATE: "E-Invoice Enable Date",
        LBL_EINV_MISC_CODE: "E-Invoice MSIC Code",
        LBL_EINV_MISC_DESC: "E-Invoice MSIC Desc",
        LBL_CATEGORY_TYPE: "类别类型",
        LBL_SHIPMENT_TYPE: "运输类型",
        LBL_SHIPMENT_MODE: "装运方式",
        LBL_FULL_MARKING: "Full 客户代号",
        LBL_CONTACT: "联络",
        LBL_MOBILE: "手机",

        LBL_FAX_NO: "传真号",
        LBL_FAX_NO_PIC: "传真联系人",
        LBL_SERIAL_NO: "序列",
        LBL_DELIVERY_ID: "Del. ID",
        LBL_TOTAL: "Total",
        LBL_ACTUAL_SO_NO: "Actual S/O No.",
        LBL_COUNTRY: "国家",
        LBL_CODE: "编码",
        LBL_NAME: "名称",
        LBL_DESCRIPTION: "描述",
        LBL_ORDER_DATE: "订单日期",
        LBL_SUPPLIER: "厂家",

        LBL_REF_ID: "Ref Id",
        LBL_LOADED_DATE: "上柜日期",
        LBL_ROW_ID: "Row Id",

        LBL_CREATED_ON: "创建于",
        LBL_AUTO_SAVE: "自动保存",
        LBL_VERSION_NO: "版本号",
        LBL_SST_NO: "SST No.",
        LBL_SHOW_DETAIL: "Show Detail",
        LBL_DOC_DATE: "Doc Date",
        LBL_USER: "用户",
        LBL_EXP: "单证出口",

        LBL_CTN: "件数",
        LBL_KG: "重量",
        LBL_M3: "M3",
        LBL_AMOUNT: "金额",
        LBL_DATE: "日期",
        LBL_LOADING_STATUS: "Loading Status",
        LBL_DUE_DAYS: " 付款天数",
        LBL_PAYMENT_TYPE: "Payment Type",
        LBL_API_CLIENT_ID: "Client Id",
        LBL_API_CLIENT_KEY: "Client Key",
        LBL_EXPIRED: "过期",
        LBL_CUSTOMER: "Customer",
        LBL_REGISTER_NO: "Register No.",
        LBL_REGISTER_NO_NRIC: "Register No/Nric",
        LBL_SUMMARY_OPTIONS: "Summary Options",
        LBL_SCS_REMARK: "SCS Remark",

        FORM_EMAIL_DESC: "例如: example@gmail.com;example1@gmail.com",

        TXT_ALL: "全部",
        TOTAL_TITLE: "总额",
        TXT_RANGE: "{from} - {to} 之间",
        TXT_ABV: ">= {from}",
        TXT_BELOW: "<= {to}",

        SELECTION_OTHERS: "其他",
        PH_ENTER_TEXTBOX: "输入 {txt_fieldname}",
        PH_ENTER_DATE: "输入日期",
        PH_ENTER_DATE_FROM: "输入 {name} 从",
        PH_ENTER_DATE_TO: "输入 {name} 至",
        PHP_ENTER_SEARCH: "Enter {name} To Search",
        MSG_SUPPORT_IMAGE_SIZE_FORMAT:
            "图片大小应小于1 MB,支持的格式为.jpg、.jpeg、.png",
        MSG_IMAGE_FORMAT_NOT_SUPPORTED:
            "图像格式不支持。支持的格式: .jpg, .jpeg, .png",
        MSG_SUPPORT_DOC_SIZE_FORMAT: "文档大小应小于10 MB",
        MSG_PROGRESS: "Please wait a moment ... ....",
        MSG_SUPPORT_EXCEL_FILE: "Supported File Type: .xlsx, .xls",
        MSG_ROW_ERROR: "Row: {idx}",
        MSG_COPY_FAILED: "复制失败 {name}",
        MSG_COPIED_TO_CLIPBOARD: "已复制到剪贴板",

        STATUS: {
            INACTIVE: "不活跃",
            ACTIVE: "活跃",
            SUSPEND: "暂停",
            UNVERIFIED: "未核实",
            YES: "是",
            WGI: "WGI",
            NO: "不是",
            REQUIRED: "必须",
            OPTIONAL: "选填",
            DRAFT: "草稿",
            PENDING: "待定",
            APPROVED: "已审核",
            REJECTED: "已拒绝",
            VERIFY: "核实中",
            CLOSED: "已关闭",
            OPEN: "打开",
            ACKNOWLEDGE: "确认",
            NEW: "新",
            EXPIRE: "到期",
            VALID: "有效",
            LOCKED: "禁用",
            REJECT: "拒绝",
            REVERT: "还原",
            VERIFIED: "已核实",
            BLOCKED: "阻止",
            SUSTAINED_EFFECTIVE: "持续实效",
            CONFIRM: "已确认",
            RECEIVE_GOODS: "已收货",
            PENDING_ACKNOWLEDGE: "待确认",
            ACKNOWLEDGED: "已确认",
            REQUEST_REVERT: "请求还原",
            REVERTED: "已还原",
            DONE: "已付款",
        },

        MSG: {
            API_SERVER_DOWN: "服务器连接被拒绝。请联系系统管理员。",
            MSG_DATA_NOT_FOUND: "未找到记录",
            DATA_NOT_AVAILABLE: "无可用数据",
            SUCCESSFUL_IMPORT_EXCEL: "已成功导入Excel",
            API_SERVER_DOWN_WITH_NAME: "{name} 服务器连接被拒绝，请联系系统管理员",
            AGENT_PATH_MISSING: "{name} route not set",
            VERSION_NOT_MATCH: "数据已修改，请重新加载。",
            NETWORK_ERR: "网络连接不稳定",
            NETWORK_MESS: "我们检测到网络错误。请确保您有稳定的互联网连接，然后重试",
            TIMEOUT_ERROR: "系统超时",
            TIMEOUT_MESS: "您的会话已超时。请重新登录",
            CONFIRM_RESET: "数据将被重置。确定要继续吗?",
            DOC_FILE_SIZE: "允许的文件大小不得超过 {size} MB。",
            SUCCESSFULL_DOWNLOAD_FILE:
                "文件已成功下载。请检查您设备的“下载”文件夹或指定的保存位置。",
            ERROR_SEARCH_FAILED:
                "Search Api failed call, Please contact System Admin.",
            SUPPORT_ASCII: "{name} 仅支持字母、数字和标准符号。",
            FAILED_TO_GENERATE_PDF: "PDF 导出失败: {error}",
        },

        VALIDATION: {
            INVALID: "{name}无效",
            REQUIRED: "{name}为必填项。",
            REQUIRED_GREATER_ZERO: "{name}必须大于零",
            MIN_LENGTH: "{name}最小长度是{min}",
            AGREEMENT_REQUIRED: "需要接受条款和条件",
            NOT_FOUND: "{name}找不到请求",
            REF_NOT_FOUND: "单号: {ref_no}找不到",
            INVALID_LOGIN: "登录详细信息不正确",
            REQUIRED_FIELD: "必填字段",
            MIN_LENGTH_FIELD: "最小字段长度：",
            MAX_LENGTH_FIELD: "最大字段长度：",
            INVALID_FIELD: "字段无效",
            NUMBER: "{name}必须是数字",
            CANNOT_EQUAL: "{p1}不能相同{p2}",
            EXPIRE: "{name}必须大于当前日期",

            MISSING_REQ_DATA: "请填写所有详细信息",
            INVALID_WARNING_MSG: "请提供正确的数据！",
            DUPLICATE_ENTRY: "{name}重复。请重试",
            UNIQUE_FIELD: "{name}必须是独特的",
            REF_NO_DUPLICATE: "{name}: {ref_no} 重复输入。",
            DOCUMENT_NUMBERING_NOT_SET: "单号格式找不到. 请联系系统管理员。",
            DOC_NUMBER_NOT_SET_TYPE: "{doc_type}单号格式找不到. 请联系系统管理员。",
            ID_NOT_FOUND: "未找到相关数据",
            MISSING_DOC_TYPE: "单号类型: {doc_type}找不到. 请联系系统管理员。",
            UNIQUE_VALUE: "{code} 不可用",
            STATE_CODE_REQUIRED: "State code is not set",
            MARKING_NOT_EXISTS: "客户代号不存在",
            DOCUMENT_NO_DUPLICATE: "单号复制",
            DOCUMENT_NO_type_DUPLICATE:
                "Document Number is duplicate ({doc_type}). Please try again.",
            DATE_FROM_GREATER_THAN_DATE_TO: "{date_to}必须大过{date_from}",
            AMOUNT_GREATER_THAN: "{name} must be greater than {field}",
            DATA_NOT_FOUND_REQ_CREATE: "{code}无法找到。请创建新记录",
            DATA_NOT_FOUND: "{data} record not found",

            INVALID_CONTACT_NO_FORMAT: {
                FORMAT_MY: "{name}格式错的, 正确的格式 eg: 123456789",
            },
            POSITIVE: "{name} 只允许输入正数",
            RECORD_NO_SELECTED: "尚未选择任何数据",
            INVALID_DATE_FORMAT_EXCEL: "{name} 不支持日期格式",
            ROW_DATA_NOT_FOUND: "Row: {idx}未找到相关数据",
            DUPLICATE_RECORD_SET: "重复设置",
            DOCUMENT_FORMAT_LENGHT: "No. 格式不能超过 {len} 个字符",
            DOCUMNET_NUMBER_FORMAT_DUPLICATE_SET: "No.Format: {format} 重复了",
            EXCEL_FILE_NOT_UPLOAD: "请上传产品excel文件",
            EXCEL_FILE_TYPE_INVALID: "Excel文件类型无效",
            EXCEL_IMPORT_DATA_NOT_FOUND: "找不到上传的数据",
            EXCEL_DATA_INCORRECT: "请确保上传的数据正确",
            CURRENCY_RATE_NOT_SET: "Daily rate is not set",
            CURRENCY_RATE_DEFAULT_NOT_SET:
                "{currency} conversion setting not set. Please contact Person In Charges",
            IS_EMPTY: "{name} is empty.",
            DUPLICATE_TBL_ROW: "{name} is duplicated with row {index}",
            FILE_TYPE_INVALID: "{name} File Type Invalid",
            FILE_SIZE_EXCEEDED: "File size too large. Maximum size: {file_size} MB",
            EXCEL_SHEET_NOT_FOUND: "在 Excel 文件中找不到{name}工作表",
            ASCII_KEY_CODE: "** ITEM CODE 包含不支持的字符。请仅使用英文字母和数字",
            ASCII_INVALID: "{name} 包含不支持的字符。仅支持字母、数字和标准符号。",
            MAX_LEN_FIELD: "{name} 最大字段长度 {len}。",
            MODULE_ID_REQUIRED: "{mod} id 是必须。",
            NO_DATA_TO_EXPORT: "没有数据导出Excel。",
        },

        BTN_DOWNLOAD_ALL_AS_PDF: "全部下载为PDF",
        BTN_DOWNLOAD_AS_PDF: "下载为PDF",
        BTN_REJECT: "拒绝",
        BTN_VERIFY: "核实",
        BTN_SEARCH: "搜索",
        BTN_CLEAR: "清除",
        BTN_CLEAR_FORMAT: "清除格式",
        BTN_CANCEL: "取消",
        BTN_BACK: "返回",
        BTN_SAVE: "保存",
        BTN_BROWSE: "浏览",
        BTN_EDIT: "编辑",
        BTN_REVERT: "还原",
        BTN_CREATE: "新建{btn_name}",
        BTN_SUBMIT: "提交",
        BTN_APPROVE: "批准",
        BTN_ADD: "添加",
        BTN_DELETE: "删除",
        BTN_COPY: "复制",
        BTN_CLOSE: "关闭",
        BTN_OPEN: "Open",
        BTN_CONFIRM: "确认",
        BTN_ACKNOWLEDGE: "同意",
        BTN_PREVIEW: "预览",
        BTN_SAVE_AS_DRAFT: "另存为草稿",
        BTN_PRINT: "打印",
        BTN_PRINT_ALL: "全部打印",
        BTN_CONFIRM_N_APPROVE: "确认并批准",
        BTN_VIEW: "查看",
        BTN_RESET: "重置",
        BTN_DOWNLOAD_ALL: "全部下载",
        BTN_DOWNLOAD_SELECTED: "下载所选",
        BTN_COST_SETUP: "Cost Setup",
        BTN_LEAVE: "离开页面",
        BTN_STAY: "留在页面上",
        BTN_REFRESH: "刷新",
        BTN_OK: "好的",
        BTN_UPLOAD: "上传",
        BTN_IMPORT: "导入Excel",
        BTN_POST: "Post",
        BTN_REVERSE: "撤销",
        BTN_SYNC_ALL: "全部同步",
        BTN_SYNC_ALL_WAREHOUSE: "全部同步至仓库",
        BTN_SYNC_ALL_AGENT: "全部同步至代理",
        BTN_PREVIEW_IMAGE: "预览图像",
        BTN_PREVIEW_DOC: "预览文档",
        BTN_UPLOAD_IMAGE: "上传图片",
        BTN_UPLOAD_DOC: "上传文件",
        BTN_ALL: "全部",
        BTN_HISTORY: "历史",
        BTN_SYNC_TO_AGENT: "同步至代理",
        BTN_SYNC_TO_WAREHOUSE: "同步至仓库",
        BTN_POST_TO_ACCOUNT: "Post To Account",
        BTN_NEW: "新",
        BTN_SKIP: "跳过",
        BTN_ENABLE_EDIT: "启用编辑",
        BTN_DISABLE_EDIT: "关闭编辑",
        BTN_COPY_EDIT: "复制/编辑",
        BTN_IGNORE: "忽略",
        BTN_SELECT: "选择",
        BTN_LINK: "链接",
        BTN_REMOVE: "祛除",
        BTN_DROP_FILE: "点击或拖拽{file}文件到该区域即可上传",
        BTN_DROP_FILE_SIMPLE: "Click or Drag {file}",
        BTN_CLICK_HERE: "点击这里",
        BTN_ADD_FROM_SO_RECEIVED: "Add from S/O Received",
        BTN_YES: "确定",
        BTN_NO: "拒接",
        BTN_REMOVE_SORT: "删除排序",
        BTN_ENABLED: "Enable Edit {name}",
        BTN_DISABLE: "Disable Edit {name}",
        BTN_EXPORT_EXCEL: "Export To Excel",
        BTN_COLLPASE_ALL: "全部折叠",
        BTN_EXPAND_ALL: "全部展开",
        BTN_SAVE_AND_COPY: "保存并复制",
        BTN_SAVE_AND_NEW: "保存并添加",

        BTN_MANUAL: "手动",
        BTN_AUTO: "自动",
        BTN_EXPORT_TO_EXCEL: "Export To Excel",
        BTN_APPLY: "提交",
        BTN_DELETE_ALL: "全部删除",
        BTN_AR_REJECT: "AR Reject",

        FILE_TYPE: {
            EXCEL: "Excel",
            PDF: "PDF",
            IMAGE: "Image (s)",
        },

        COL_RECEIVED_AMOUNT: "接受金额",
        COL_RECEIVED_DATE: "收货日期",
        COL_CODE: "编码",
        COL_NAME: "名称",
        COL_EMAIL: "电邮",
        COL_SHIPMENT_TYPE: "运输类型",
        COL_COUNTRY: "国家",
        COL_CREATED_ON: "Created On",
        COL_WAREHOUSE: "仓库",
        COL_EXPIRED_DATE: "Expired Date",
        COL_LOADED_DATE: "Loaded Date",
        COL_COMPANY_SUB_GRP: "Comp Sub Grp.",
        COL_MSM: "Msm",
        COL_SM: "Sm",
        COL_MODIFIEDBY: "Modified By",
        COL_CREATEDBY: "Created By",
        COL_DELIVERY_ZONE: "Del. Zone",
        COL_DISCOUNT_AMOUNT: "Disc Amt",

        USER_TYPE: {
            INTERNAL_STAFF: "内部员工",
            MAIN_SALESMAN: "Main Salesman",
            SALESMAN: "Salesman",
            SYSTEM_ADMIN: "系统管理员",
            WAREHOUSE_STAFF: "仓库/办公室人员",
            AGENT_STAFF: "代理人员",
        },

        TITLE: {
            SUMMARY: "{name}列表",
            CREATE: "创建{name}",
            DETAIL: "{name}详情",
            EDIT: "编辑{name}",
            INQUIRY: "查询{name}",
        },

        TITLE_DETAILS: "详情",
        TITLE_SUMMARY: "简略",
        TITLE_RESHIP_ITEM: "Reship Item",
        TITLE_EXCLUDE_SHIP: "Exclude Ship",

        TRANS_TYPE: {
            COURIER: "快递",
            LOGISTIC: "物流",
        },
        RICH_TEXT_EDITOR_HEAD: {
            NORMAL_TEXT: "内文",
            HEADING_ONE: "标题 1",
            HEADING_TWO: "标题 2",
            HEADING_THREE: "标题 3",
            HEADING_FOUR: "标题 4",
            HEADING_FIVE: "标题 5",
            HEADING_SIX: "标题 6",
        },
        RICH_TEXT_EDITOR_WORD: "字数: {word_count} | 字符数: {character_count}",

        DOCUMENT_LANGUAGE_SELECTION: {
            CN: "中文",
            EN: "英文",
            TH: "泰文",
        },

        GRN_FORMAT: {
            DEFAULT: "默认",
            DUO_LANGUAGE: "双语",
        },

        PAYMENT: {
            OUTSTANDING: "OutStanding",
            FULLY_PAID: "Fully Paid",
            CLOSED_ORDER: "Closed Order",
          FULLY_CANCELLED: "Fully Cancelled",
    },
    },
    MENU: {
        ASIDE: {
            CATEGORY_PARENT: "货品类别（父级）",
            CATEGORY: "货品类别 (2 级)",
            MISSING_STATUS_INQUIRY: "处理缺失订单",

            USER: "用户",
            ROLE: "角色",
            DATA_FILTER: "过滤数据",
            USER_N_ROLE_MANAGEMENT: "用户及角色管理",
            USER_GROUP: "用户群",
            SHIPMENT: "运输",
            SHIPMENT_TYPE: "运输类型",
            SHIPMENT_MODE: "装运方式",
            COURIER_COMPANY: "快递公司",
            DELIVERY_AGENT: "快递代理",
            LANGUAGE: "语言",
            CONSIGNMENT_SO: "快递订单",
            EPO_MANAGEMENT: "托运单管理",
            PACKING_TYPE: "包装类型",
            PRODUCT_MANAGEMENT: "货品管理",
            SETTINGS: "设置管理",
            SYSTEM_SETTINGS: "系统设置",
            TRANSACTION_SETTINGS: "交易设置",
            GENERAL_SETTINGS: "基础设置",
            AGENT: "Gbizs代理设置",
            WAREHOUSE_SETTINGS: "仓库设置",
        },
        HEADER: {
            TUTORIAL: "教学",
            TUTORIAL_EN: "英文版",
            TUTORIAL_CN: "中文版",
        },
    },
    AUTH: {
        BTN_SIGN_OUT: "登出",
        USERNAME_TITLE: "嗨, {username}",
        FORGOT_PASSWORD: {
            MSG_RESET_PASSWORD_MESSAGE_DELIVERED:
                "邮件已发送至您的收件箱。如果您在收件箱中找不到该邮件，请检查您的垃圾邮件或垃圾文件夹，因为它可能已被过滤。",
            TITLE: "忘记密码",
            DESC: "输入您的电子邮件以重置密码",
            SUCCESS: "密码重置成功！ 您现在可以使用新密码登录",
            FAILED:
                "很抱歉，我们暂时无法向您的邮箱发送密码重置链接。可能的原因包括: <br />1.  输入的邮箱地址未注册或存在拼写错误。<br />2. 邮件被误判为垃圾邮件（建议检查垃圾箱）<br />3. 系统临时延迟（请5分钟后重试）",
        },
        RESET_PASS: {
            RESET_PASS_TITLE: "重置您的密码",
            RESET_PASS_DESC: "更改您的新密码",
            PASS: "新密码",
            COMFIRM_PASS: "确认密码",
            TOKEN_EXPIRED: "令牌已过期",
            PASS_REQUIRED: "請输入密码",
            COM_PASS_REQUIRED: "請输入确认密码",
            PASS_COM_NOT_SAME: "密码和确认密码不一致",
            UPDATE_SUCCESS: "您的密码已成功更新",
            PROVIDE_CORRECT_DATA: "Please, provide correct data!",
        },
        PASSWORD: {
            PASSWORD_LENGTH: "密码须8至12字符",
            CONTAIN_AT_LEAST_LOWER_CASE: "最少1个小写字母",
            CONTAIN_AT_LEAST_UPPER_CASE: "最少1个大写字母",
            CONTAIN_AT_LEAST_ONE_DIGIT: "最少1位数字",
            CONTAIN_AT_LEAST_SPECIAL_CHARACTER: "最少1个特殊字符(#?!@$%^&*-)",
            PASSWORD_REQUIREDMENT_TITLE: "密码要求： ",
        },
        RESPONSE_MSG: {
            ACCOUNT_STATUS_INVALID: "登录账户已失效/已删除。",
        },
        APIAUTH: {
            RESET_API_CREDENTIAL: "Reset Api Credential",
            MSG_SUCCESSFUL_UPDATE: "Api Credential Successful updated",
            MSG_FAILED_UPDATE: "Api Credential Failed updated",
        },
    },
    EPO: {
        FORMAT_CN: "中文版",
        FORMAT_EN: "英文版",
        FORMAT_IN: "印尼文版",
        FORMAT_TH: "泰文版",
        FORMAT_VN: "越南文版",
        VIEW_PRODUCT_DETAIL: "Epo No.: {epo_no} Courier / Product Detail (s)",
        DOWNLOAD_EPO_IMPORT_EXCEL_FORMAT: "下载导入产品Excel格式",
        BTN_IMPORT_PROD: "导入产品",
        BTN_PRODUCT: "货物详情",
        BTN_UPD_EPO: "修改EPO头详情 ",
        UPLOAD_RPODUCT_TITLE: "导入产品Excel文档·",

        MSG: {
            EXCEL_SHEET_NOT_FOUND: "{name} Sheet not found in excel file",
            EXCEL_FORMAT_NOT_FOUND: "{name} Sheet Column not matching!",
            EXCEL_DATA_EMPTY: "{name} Sheet no data set",
            PARCEL_GUARANTEE_ADD_CHARGES_CUSTOMER:
                "需额外收取货物保障费用，请联系负责人",
            PARCEL_GUARANTEE_ADD_CHARGES_ADMIN:
                "需额外收取货物保障费用，请与客户确认",
            PARCEL_GUARANTEE_CONFIRMATION: "需额外收取货物保障费用。您确定要继续吗？",
            CONSIGNMENT_NO_DUPLICATE_EPO: "快递单号: {ref_no}已经用在其他的托运单号.",
            ERROR_SEARCH_FAILED: "搜索接口调用失败，请联系系统管理员",
            ITEM_CODE_ERROR:
                "ITEM CODE 只能包含英文字母、数字和标准符号，且不得超过 20 个字符。",
            CONFIRM_UPDATE_WAREHOUSE_DETAIL: "更新仓库地址及联络号",
        },
        BTN_ADD_PROD: "添加商品",

        LBL_HAS_TAX_REBATE: "退税",
        LBL_EPO_TYPE: "发送至仓库方式",
        LBL_CONSIGNMENT_NO: "快递号",
        COL_CONSIGNMENT_ARRIVED_WAREHOUSE: "已接收快递",
        LBL_INC_RCV: "包含已到仓",

        EPO_TYPE: {
            ORDER: "订单",
            COURIER: "快递",
        },

        TITLE_UPD_EPO: "修改EPO头详情",
    },
    CUSTOMER: {
        REQUEST_TYPE: {
            CREATE_TYPE: "新建",
            UPDATE_TYPE: "更新",
        },
        STATUS: {
            PENDING: "Pending",
            VERIFYING: "Verifying",
            APPROVED: "Approved",
            REJECTED: "Rejected",
        },
        LBL_SAVE_DELIVERY_ADDRESS: "另存为送货地址",
    },
    TT: {
        BENE_MODEL: {
            BENE_TITLE: "Beneficiary Details",
            INTERMEDIATE_TITLE: "Intermediate Bank Details",
            INTERMEDIATE_CHECKBOX: "Intermediate Bank?",
            ACC_HOLDER: "Account Holder",
            ACC_NO: "Account Number",
            BENE_CONTACT_PIC: "Bene Contact PIC",
            BENE_CONTACT_CALLING_CODE: "Bene Calling Code",
            BENE_CONTACT_NO: "Bene Contact Number",
            RI_NO: "Ri Number",
            BANK_NAME: "Bank Name",
            BANK_CITY: "Bank City",
            BANK_COUNTRY: "Bank Country",
            BANK_ADDRESS: "Bank Address",
            BENE_ADDRESS: "Bene Address",
            BANK_REMARK: "Bank Remark",
            BANK_CODE: "BIC / Swift Code",
            IBAN: "IBAN",
            INTER_BANK_NAME: "Intermediate Bank Name",
            INTER_BANK_ACC: "Intermediate Account No",
            INTER_SWIFT_CODE: "Intermediate BIC / Swift Code",
            INTER_IBAN_CODE: "Intermediate IBAN Code",
            BENE_DETAIL_NAME: "Beneficiary Detail Name",
        },
        TYPE: {
            DEPOSIT: "预付",
            PAYMENT: "付款",
        },
    },
    GRN_FORMAT: {
        HEADER: {
            DATE: "日期",
            SUPPLIER: "供应商",
            SUPPLIER_CODE: "供应商代码",
            REMARK: "备注",
            MOBILE: "手机",
            CONTACT_PERSON: "联系人",
            DOC_NO: "单号",
            PHONE_NO: "电话",
            PAYMENT_METHOD: "付款方式",
            RECEIPT: "收据",
            SHARED_SO: "共单号",
            COURIER_COMPANY: "快递公司",
            CONSIGNMENT_NO: "快递号",
            AC_NO: "帐号",
            AC_NAME: "帐户",
            BANK_NAME: "银行",
            BRANCH: "分行",
            NOTICE_ID: "",
            DUE_DATES: "PN",
        },
        CONTENT: {
            SERIAL_NO: "序号",
            CUSTOMER_MARKING: "客户代号",
            SO_NO: "订单号",
            CTN: "件数",
            WEIGHT: "重量",
            DIMENSION: "体积",
            OTHER: "其他",
            PN: "PN",
            TOTAL: "总额",
            CONSIGNMENT_NO: "快递号",
            CURRENCY: "货币",
            TOTAL_AMT: "总金额",
            DISC: "折扣",
            DEPOSIT: "预付定金",
            OTH_CHARGES: "其他费用",
            BAL_AMT: "余额",
            DUE_DATES: "截止日期",
        },
        FOOTER: {
            DELIVER: "送货人签名",
            PERSON_IN_CHARGES: "经手人",
            CONTACT_PERSON: "联系人",
            CONTACT_NO: "电话",
        },
    },
    PN_FORMAT: {
        HEADER: {
            DATE: "日期",
            SUPPLIER: "供应商",
            SUPPLIER_CODE: "供应商代码",
            REMARK: "备注",
            MOBILE: "手机",
            CONTACT_PERSON: "联系人",
            DOC_NO: "单号",
            PHONE_NO: "电话",
            PAYMENT_METHOD: "付款方式",
            ACCOUNT_NAME: "账户名",
            ACCOUNT_NO: "账号",
            BANK_ADDRESS: "开户行",
            BANK_NAME: "银行名",
        },
        CONTENT: {
            SERIAL_NO: "序号",
            CUSTOMER_MARKING: "客户代号",
            SO_NO: "订单号",
            CURRENCY: "币种",
            CTN: "件数",
            WEIGHT: "重量",
            DIMENSION: "体积",

            TOTAL_AMT: "总金额",
            DISCOUNT: "折扣",
            DEPOSIT: "订金",
            STICKER_FEE: "扣贴纸费",
            BALANCE_AMT: "余额",
            TOTAL: "总额",
        },
        FOOTER: {
            DELIVER: "送货人签名",
            PERSON_IN_CHARGES: "经手人",
            CONTACT_PERSON: "联系人",
            CONTACT_NO: "电话",
        },
    },
    REPORT: {
        COMMON: {
            COL_SERIAL_NO: "No.",
            COL_EFFECTIVE_DATE: "Effective Date",
            COL_DEPOSIT_NO: "Deposit No.",
            COL_CUSTOMER_MARKING: "Marking",

            TOTAL: "Total",
            MAIN_SALESMAN: "Main Salesman",
            SALESMAN: "Salesman",
            DELIVERY_ID: "Delivery Id",
            SO_NO: "S/O No.",
            REPORT_FILTER: "Report Filter",
            FROM_TO: "From {value_from} To {value_to}",
            FROM: "From {value_from}",
            TO: "To {value_to}",
            WAREHOUSE: "Warehouse",
            USER: "User",
            NOTICE_TYPE: "Notice Type",
            CURRENCY: "Currency",
            SHOW_M3: "Show M3?",
            SHOW_AMOUNT: "Show Amount?",
            SHOW_CREDIT_PAYMENT: "Credit Payment?",
            WH_CHARGES_AMT: "W/H Chrg",
            GRAND_TOTAL: "Grand Total",
            REF_NO: "Ref No.",
            LOADED_AMOUNT: "Loaded Amount",
            LOADED_DATE: "Loaded Date",
            BILLING_AMOUNT: "Billing Amount",
            CUST_DEPOSIT: "Cust Deposit",
            MY_PAID: "My Paid",
            FCP_CP: "Fcp/CP",
            SUP_DEPOSIT: "Sup Deposit",
            CASH_PAYMENT: "Cash",
            DELIVERY_DATE: "Delivery Date",
            PARTNER_ID: "Partner Id.",
            SHIPMENT_TYPE: "Shpt. Type",
            SHIPMENT_MODE: "Shpt. Mode",
            HISTORY: "History",
        },
        PACKING_LIST_FORMAT: {
            SERIAL_NO: "S/N",
            SO_NO: "S/O No.",
            SUPPLIER_NAME: "Sup Name",
            T_M3: "T/M3 (T/CM3)<br />总立方 ",
            T_KG: "T/Kg (Vol Weight)<br />总重量",
            T_QTY: "T/Pqty<br />总件数",
            BILL_AMT: "Bill Amt",
            LOADED_AMOUNT: "Loaded Amt",
            CUS_DEPOSIT: "Cus Deposit<br />客付定金",
            MY_PAYMENT: "My P'ment<br />马来付",
            FCP_AMT: "FCP Amount<br />客付定金",
            SUP_DEPOSIT: "Sup Deposit<br />国际付定金",
            LOCAL_PAYMENT: "Local P'ment<br />国际付款",
            WAREHOUSE_CHARGES: "Wh Chrgs<br />仓库费用",
            DISC_AMOUNT: "Disc Amt<br />折扣金额",
            REPORT_TITLE: {
                SUMMARY: "Packing List Summary (B) New",
                DETAIL: "Packing List Details (C) New",
            },

            STOCK_DESC: "Stock Short Desc",
            M3: "M3<br />立方",
            KG: "Kg<br />重量",
            P_QTY: "P Qty<br />件数",
            QUANTITY: "Quantity<br />数量",
            UOM: "Uom<br />单位",
            UNIT_PRICE: "Unit Price<br />单价",
            AMOUNT: "Amount<br />金额",
            RECEIVE_DATE: "Received Date",
            REF_ID: "Ref ID",
            MAIN_SALESMAN: "Main Salesman",
            SALESMAN: "Salesman",
            CUSTOMER_MARKING: "Marking",
            DELIVERY_ID: "Delivery Id",

            REPORT_FILTER: "Report Filter",
            SHOW_M3: "Show M3?",
            SHOW_KG: "Show Kg?",
            SHOW_BILL_AMOUNT: "Show Bill Amount?",
            SHOW_STOCK_DESC1: "Show Stock Desc 1?",
            SHOW_STOCK_DESC2: "Show Stock Desc 2?",
            SHOW_SUPPLIER: "Show Supplier",
            YES: "Yes",
            NO: "No",
            CURRENCY_ID: "Currency ID",
            REMARK: "Remark",
            REMARK2: "Remark 2",
            UNLOAD_AMOUNT: "Unload Amount",
            DEPOSIT_DATE: "D. Date",
            DEPOSIT_NO: "PN #",
            DEPOSIT_RATE: "TR",
            DEPOSIT_AMOUNT: "TS Amt",
            DEPOSIT_CHARGE: "FTC",
            DEPOSIT_CHARGE_MYR: "TC (RM)",
            DEPOSIT_IR: "IR %",
            DEPOSIT_OR: "AOR No.",
            SO_AMOUNT: "SO Amount",
            REF_NO: "Ref No.",
            OTHER_REF_LOADED_AMT: "Loaded Amt",
            OTHER_REF_M3: "M3",
            OTHER_REF_KG: "KG",
            OTHER_REF_CTN: "Ctn",

            SUB_TTL_T_M3: "T/M3",
            SUB_TTL_T_KG: "T/Kg",
            SUB_TTL_T_PQTY: "T/Pqty",
            SUB_TTL_REF: "Ref ",
            SUB_TTL_VOL_WEIGHT: "Vol Weight",
            SUBTOTAL: "SubTotal",
            CURRENCY: "Currency",
            GRANDTOTAL: "Grand Total",
        },
        STOCK_BALANCE_FORMAT: {
            TITLE: "Stock Balance Report with Payment Info",
            DETAIL: "Detail",
            SUMMARY: "Summary",
            SERIAL_NO: "S/N",
            CURRENCY_ID: "Cur ID",
            SO_NO: "S/O No.",
            RECEIVE_DATE: "Rec Date",
            NOTICE_ID: "Notice ID",
            TOTAL_M3: "Total M3",
            TOTAL_PACK: "Total Pack",
            BAL_AMT: "Balance Amount",
            CUS_DEPOSIT: "Cust Deposit",
            MY_PAYMENT: "My Payment",
            SUP_DEPOSIT: "Sup Deposit",
            CASH_PAYMENT: "Cash P'ment",
            CREDIT_PAYMENT: "Credit P'ment",
            FCP_AMOUNT: "FCP Amount",
            PAYABLE_AMT: "Payable Amt",

            PO_DATE: "PO Date",
            STOCK_SHORT: "Stock Short",
            STOCK_DESC: "Stock Desc",
            M3: "M3",
            BAL_PACK: "Bal Pack",
            QUANTITY: "Quantity",
            PURCHASE_PRICE: "Purchase Price",
            AMOUNT: "Amount",
            MAIN_SALESMAN: "Main Salesman",
            SALESMAN: "Salesman",
            CUSTOMER_MARKING: "Marking",
            DELIVERY_ID: "Delivery Id",
            OR_DATE: "O/R Date",
            LOADED_DATE: "Loaded Date",

            // For warehouse summary
            BY_WAREHOUSE_TITLE: "Stock Balance Report By Warehouse",
            COMPANY_GROUP_ID: "C/ID",
            FULL_MARKING: " Msm/Sm/Marking/*Deli ID* (Partner ID)",
            CTN_NO: "Ctn No",
            WH_ID: "W ID",
            RECEIVE_DATE2: "Rec'd Date",
            TOTAL_KG: "Total KG",
            TOTAL_AMOUNT: "Total Amount",
            WAREHOUSE_ID: "Warehouse ID",
            AGENT_ID: "Agent ID",

            // REPORT_FILTER: "All / KCG Only / Exclude KCG",
            FROM: "From",
            TO: "To",
            REPORT_FILTER: "Report Filter",
            REPORT_OPTIONS: "Report Options",
            DELIVERY_ID_TOTAL: "Delivery ID Total",
            MARKING_TOTAL: "Marking Total",
            SALESMAN_TOTAL: "Salesman Total",
            MAIN_SALESMAN_TOTAL: "Main Salesman Total",
            CURRENCY_TOTAL: "Currency Total",
        },
        DO_FORMAT: {
            FORMAT_TITLE: "DELIVERY ORDER",
            TEL_NO: "Tel No.",
            GOODS_RECEIVE_CONDITION: "Goods received in good order & condition",
            SIGNATURE_TITLE: "Authorised Signature & Co Stamp",
            FOOTER_E_DESC: "Computer Generated, no signature required",
            FOOTER_END: "== End ==",

            DONO: "D/Order #",
            REF_ID: "Yr Ref",
            DO_DATE: "Date",
            TRANPORTER: "T-Ref",
            PAGE: "Page",
            MOBILE_NO: "Mobile No.",
            FORWARDER: "Forwarder",
            FAX: "Fax",
            REMARK1: "Remark1",
            REMARK2: "Remark2",
            SERIAL_NO: "S/N",
            SO_NO: "",
            DESCRIPTION: "Description",
            QUANTITY: "Quantity",
            UNIT: "Unit",
            PKG: "Pkg",
            QTY: "Qty",
            TOTAL_M3: "Total M3",
            TOTAL_KG: "Total KG",
            TOTAL_PACKING: "Total Packing",
            SEND_ON_BEHALF: "Send on behalf of",
        },
        RCV_PAYMENT: {
            LBL_REQUEST_AMOUNT: "金额",
            LBL_PN_NO: "欠单号",
            LBL_MARKING: "代号",
            LBL_STICKER_FEE: "扣贴纸家",
            LBL_DOC_NO: "单号",
        },
    },
    MASTER_DATA: {
        DELIVERY_AGENT: {
            MODULE_NAME: "快递代理",
            LISTING_TITLE: "快递代理列表",
            CREATE_TITLE: "创建快递代理",
            DETAIL_TITLE: "快递代理详情",
            EDIT_TITLE: "编辑快递代理",
            CODE: "代理编码",
            NAME: "代理名",
            LABEL: "标签",
            DELIVERY_ZONE: "送货区",

            LBL_COURIER: "快递",
            LBL_COURIER_LIST: "支持快递",
            LBL_URL_TRACKING: "跟踪网址",
            NORMAL_GOODS_CAPTION: "Normal Goods Caption",
            SENSITIVE_GOODS_CAPTION: "Sensitive Goods Caption",
            COURIER_CHANNEL_NAME_CAPTION: "Courier Channel Name Caption",

            MSG_COUNTRY_COURIER_NOT_SET: "{name} 快递未创建.",
        },
        SHIPMENT_MODE: {
            SHIPMENT: "运输",
            SHIPMENT_TYPE: "运输类型",
            SHIPMENT_MODE: "装运方式",
            LISTING_TITLE: "装运方式列表",
            CREATE_TITLE: "创建装运方式",
            DETAIL_TITLE: "装运方式详情",
            EDIT_TITLE: "编辑装运方式",

            LBL_SHIPMENT_MODE_CODE: "装运方式编码",
            LBL_SHIPMENT_MODE_NAME: "装运方式名称",
            LBL_SHIPMENT_TYPE: "支持运输类型",
            LBL_QUOTATION_REMARK: "报价备注",
            LBL_COST_SETUP: "价格设置？",
            LBL_SUPPORTED_COUNTRY: "支持国家",
            SUPPORTED_COUNTRIES_MSG: "** 支持所有国家/地区，字段设置为空",
            LBL_SHIPMENT_SETTINGS: "运送设置",

            MODULE_NAME: "装运方式",

            COL_CODE: "装运方式编码",
            COL_NAME: "装运方式名称",
            COL_SHIPMENT_TYPE_NAME: "Shipment Type",
            LBL_QUOTATION_SETTINGS: "报价设置",

            MODULE_QUOTATION: " 报价 (Default)",
            MODULE_EPO: "托运单 (Default)",
            APPLY_COST_WITH_DELIVERY_AGENT: "Apply Cost with Courier Agent",
            APPLY_INV_CHARGES_DATE: "Apply Inv Chrg Date",
            LBL_DEFAULT_SELECT: "Default (Customer Portal)",
            LBL_CREATE_IV_BY_PASS_DO: "Create Invoice By Pass D/O",
        },
        COURIER_COMPANY: {
            LISTING_TITLE: "快递公司列表",
            CREATE_TITLE: "创建新的快递公司",
            DETAIL_TITLE: "快递公司详情",
            EDIT_TITLE: "编辑快递公司",
            MODULE_NAME: "快递公司",
            LBL_COURIER_TYPE: "Courier/Logistic",
        },
        PACKING_TYPE: {
            MODULE_NAME: "包装类型",

            LBL_CODE: "包装类型编码",
            LBL_NAME: "包装类型名称",
            LBL_DEFAULT: "发票默认设置",
        },
    },
    PRODUCT_MANAGEMENT: {
        CATEGORY_TYPE: {
            MODULE_NAME: "货品类别类型",
            LBL_CATEGORY_TYPE_CODE: "货品类别类型编码",
            LBL_CATEGORY_TYPE_NAME: "货品类别类型名称",

            LBL_CATEGORY_TYPE_DESCRIPTION: "货品类别类型描述",
            BTN_SET_SENSITIVE: "Set Sensitive As Default Wording",

            COL_CATEGORY_TYPE_CODE: "Category Type Code",
            COL_CATEGORY_TYPE_NAME: "Category Type Name",
            COL_USE_FOR_RECEIVING: "Use For EPO/Receiving",
            COL_PRINT_ON_QUOTATION: "Print on Quotation",
            COL_DEFAULT_QUOTE: "Must Quote",
            COL_SPECIAL_CHARGES: "Special Charges",
            COL_PRINT_ON_EPO: "Print On EPO",
            SENSITIVE_TITLE: "Sensitive",
            LBL_MUST_QUOTE: "Must Quote",
            LBL_IS_SENSITIVE: "Is Sensitive?",
            LBL_IS_CAT_DEFAULT: "Product Category Default",

            LBL_QUOTE_WITH_SPECIAL_ADD_CHARGES:
                "Quote with Special Additional Charges",
            LBL_QUOTE_WITH_PRODUCT_CATEGORY: "Quote with Product Category ",
            LBL_PRINT_ON_EPO: "Print On Epo",
            LBL_CATEGORY_TYPE_FORMAT: "EPO Format Type",
            LBL_FORMAT_TYPE_DESCRIPTION: "Format Type Description",
        },
        CATEGORY_PARENT: {
            LISTING_TITLE: "货品类别 (父级) 列表",
            CREATE_TITLE: "创建货品类别 (父级)",
            DETAIL_TITLE: "货品类别 (父级) 详情",
            EDIT_TITLE: "编辑货品类别 (父级) 详情",

            LBL_CATEGORY_CODE: "货品类别 Code",
            LBL_CATEGORY_NAME: "货品类别 Name",
            LBL_CATEGORY_PARENT: "货品类别 父级",

            MODULE_NAME: "货品类别",

            COL_CATEGORY_CODE: "货品类别 Code",
            COL_CATEGORY_NAME: "货品类别 名称",
            COL_CATEGORY_GROUP: "Category Type",
            COL_CATEGORY_PARENT: "货品类别 父级",

            COL_SERVICE_CHARGES: "服务费?",
            ROOT_SELECTION: "父级",
        },
        CATEGORY: {
            LISTING_TITLE: "货品类别 (2级) 列表",
            CREATE_TITLE: "创建货品类别 (2级)",
            DETAIL_TITLE: "货品类别 (2级) 详情",
            EDIT_TITLE: "编辑货品类别 (2级) 详情",

            LBL_CATEGORY_CODE: "货品类别 Code",
            LBL_CATEGORY_NAME: "货品类别名称",
            LBL_CATEGORY_PARENT: "货品类别(父级)",
            LBL_INVOICE_DESC: "发票说明",
            LBL_CHARGES_FLAT: "服务费",
            MSG_ASCII: "仅允许使用英文字母、数字和标准符号。",
            MODULE_NAME: "货品类别",

            COL_CATEGORY_CODE: "货品类别Code",
            COL_CATEGORY_NAME: "货品类别名称",
            COL_CATEGORY_GROUP: "Category Type",
            COL_CATEGORY_PARENT: "货品类别(父级)",
            COL_SERVICE_CHARGES: "服务费?",
            ROOT_SELECTION: "父级",
            MSG_CATEGORY_DUPLICATION: "{code} is not available.",
        },
        MATERIAL: {
            MODULE_NAME: "材料",
            LBL_MATERIAL_CODE: "材料编号",
            LBL_MATERIAL_NAME: "材料名称",
        },
    },
    PN_PAYMENT: {
        MODULE_NAME: "欠单付款",
        LBL_BADGE_NO: "Badge No.",
        LBL_DATE: "付款日期",

        SO_TITLE: "S/O详情",
        BENE_TITLE: "收款人/银行详情",

        SHOW_PAYABLE_DETAILS: "显示 PN 详细信息",
        SHOW_SO_BENE: "Show S/O Bene & Account Detail",

        LBL_DUE_DAYS: "到期日期",
        LBL_SUPPLIER: "Supplier",

        COL_SUPPLIER_DEPOSIT: "S/O Sup Deposit",
        COL_CUSTOMER_DEPOSIT: "S/O Cus Deposit",
        COL_CASH_PAYMENT: "Cash Payment",
        COL_WAREHOUSE_DISCOUNT: "Sup Wh Disc",
        COL_DISCOUNT: "折扣金额",
        COL_MY_PAID: "My Paid",
        COL_STICKER_FEES: "贴纸费用",
        COL_STICKER_FEES_PAID_AMOUNT: "厂家已付金额",
        COL_PAYABLE_AMOUNT: "欠单金额",
        COL_PAID_AMOUNT: "已付欠单金额",
        COL_PN_CANCEL_AMOUNT: "取消欠单金额",
        COL_BALANCE_PN_AMOUNT: "欠单余额",
        COL_PN_PAYMENT_AMOUNT: "欠单付款金额",
        COL_BANK_ACC_NAME: "Acc. Holder",
        COL_BANK_ACC: "Acc No.",
        COL_BANK_NAME: "Bank Name",
        COL_BANK_PROVINCE: "Bank Province",
        COL_BANK_DISTRICT: "Bank District",
        COL_BANK_ADDRESS: "Bank Address",
        COL_PN_REF_NO: "欠单付款单号",

        APPROVE_SUMMARY: "欠单付款列表",
        MODULE_NAME_APPROVE: "审批欠单付款",
        MODULE_NAME_ACKNOWLEDGE: "Acknowledge PN Payment",

        PN_PAYMENT_DETAIL_TITLE: "欠单付款详情",
        APPROVE_PN_CONFIRMATION: "后您将无法编辑此Badge No.: {badge_no}。",
    },
    BANK_BENE: {
        LBL_ACCOUNT_NAME: "银行账户名",
        LBL_ACCOUNT_NO: "银行帐号",
        LBL_BENE_CONTACT_CALLING_CODE: "Bene  联系电话代码码",
        LBL_BENE_CONTACT_NO: "收款人联系电话",
        LBL_BENE_CONTACT_PIC: "收款联系负责人",
        LBL_BENE_ADDRESS: "收款人地址",
        LBL_SAVE_AS_NEW_BANK: "保存新收款人",

        LBL_BANK_NAME: "银行名",
        LBL_BANK_COUNTRY: "银行所在国家",

        LBL_BANK_PROVINCE: "银行所在省",
        LBL_BANK_DISTRICT: "银行所在区",

        LBL_BANK_ADDRESS: "银行地址",
        LBL_BANK_RI_NO: "Ri No.",
        LBL_BANK_SWIFT_CODE: "Swift Code",
        LBL_BANK_IBAN: "Iban Code",

        LBL_INTER_BANK_NAME: "Intermediate Bank Name",
        LBL_INTER_BANK_ACCOUNT_NO: "Intermediate Acc No.",
        LBL_INTER_SWIFT_CODE: "Intermediate Swift Code",
        LBL_INTER_IBAN_CODE: "Intermediate IBAN Code",

        LBL_INTER_ENABLE: "Intermediate Bank ?",
        BANK_MODAL_TITLE: "银行列表",
    },
    SO: {
        COL_SUPPLIER_DEPOSIT: "Sup Deposit/DCP",
        COL_CUSTOMER_DEPOSIT: "Cus Deposit",
        COL_DEPOSIT: "DCP Deposit",
        COL_CASH_PAYMENT: "Cash Payment",
        COL_WAREHOUSE_DISCOUNT: "Sup Wh Disc",
        COL_DISCOUNT: "Disc. Amt",
        COL_MY_PAID: "My Paid",
        COL_STICKER_FEES: "Sticker Fees",
        COL_STICKER_FEES_PAID_AMOUNT: "Sup Pay Amt",
        COL_FCP_AMOUNT: "Fcp/CP TT",
        COL_CREDIT_AMOUNT: "Credit Amt",
        COL_SO_PAID_AMOUNT: "S/O Paid Amt",
        COL_CURRENCY_RATE: "Currency Rate",
        COL_GET_CN_AMOUNT: "Get CN Amt",
        COL_BALANCE_AMOUNT: "FCP/PN Amt.",
        COL_BLOCK_TT: "Blocked TT",
        COL_CN_TT: "CN Amt",
        COL_OUTSTANDING_AMOUNT: "OutStanding Amt",
        COL_BLOCK_AMOUNT: "Block Amt",
        COL_CN_AMOUNT: "CN Amt",
        COL_CONVERSION_FACTOR: "Currency Factor",
        COL_CN_LOCAL_AMOUNT: "CN Local Amt",
        COL_DN_LOCAL_AMOUNT: "DN Local Amt",

    COL_DN_AMOUNT: "DN Amt",
    COL_INV_AMOUNT: "Inv Amt",
    COL_SO_REV: "S/O Recv?",
    COL_CLOSE_AMOUNT: "Close Amt",
  },
  PAYMENT_INSTRUCTION: {
    IS_FULLY_CANCELLED: "取消全部SO金额",
    MSG_NO_INSTRUC_STATUS_RECORD:
      "{ref_no}:未找到指令状态为 {instruc_status} 的记录。",
    MSG_REFRESH_PAGE:
      "S/O No. ({so_no}) 对应的数据已发生变更。无法对这些记录执行 {action} 操作。请刷新页面。",
    MSG_PAID_SO:
      "以下 S/O No. ({so_no}) 已付款。无法对这些记录执行 {action} 操作。",
  },
  INV_FORMAT: {
    SERIAL_NO: "S/N",
    ITEM_DESCRIPTION: "Description",
    QUANTITY: "Quantity",
    UNIT: "Unit",
    PRICE: "Price",
    DISC: "Disc",
    AMOUNT: "Amount",
    INVOICE_TITLE: "Invoice",
    DELIVER_TO: "Deliver To",
    INVOICE_NO: "Invoice No.",
    YR_REF: "Yr Ref",
    DATE: "Date",
    TERMS: "Terms",
    TTL_PACKING: "Total Packing",
    PAGE: "Page",
    INVOICE_TERMS:
      "Accounts not paid within terms are subject to a monthly overdue charge until the balance is fully paid.",
    COMPUTER_GENERATOR: "Computer generated, no signature required",
    BANK_ACCOUNT_TITLE: "* Our Bank Account",
  },
  USER_PROFILE: {
    PROFILE_TITLE: "用户资料",
    CHANGE_PASS: "Change Password",
    VERIFY_PASS: "验证密码",
    VERIFY_DESC: "再次输入您的密码",
    PASS_NOT_MATCH: "密码不匹配",
    CURR_PASS_ERR: "当前密码错误",
    CURRENT_PASSWORD: "当前密码",
    NEW_PASS: "新密码",
    FORGOT_BUTTON: "忘记密码",
  },
  USER_N_ROLE_MANAGEMENT: {
    USER: {
      LISTING_TITLE: "用户列表",
      CREATE_TITLE: "创建新用户",
      DETAIL_TITLE: "用户详情",
      EDIT_TITLE: "编辑用户",
      RESET_LOGIN: "RESET LOGIN",
      SENT_EMAIL: "Send Email",
      NEW_PASS: "New password",
      RESET_PASS: "Change Password",
      LBL_USER_NAME: "昵称/名称",
      LBL_USER_USERNAME: "账号名",

            LBL_USER_EMAIL: "邮址",
            LBL_USER_PASSWORD: "密码",
            LBL_USER_ROLE: "角色",
            LBL_USER_DATA_FILTER: "数据过滤",
            LBL_USER_IGNORE_FILTER: "忽略数据过滤",
            LBL_DEPARTMENT: "部门",
            LBL_IGNORE_FILTER_ONLY: "仅忽略数据过滤器",
            LBL_USER_TYPE: "用户类型",
            LBL_USER_GROUP: "用户群",

            MODULE_NAME: "用户",

            COL_USERNAME: "账号名",
            COL_NAME: "昵称/名称",
            COL_LAST_LOGIN: "上次登录",
            COL_ROLES: "角色",
            COL_DATA_FILTER: "数据过滤",
            COL_IGNORE_FILTER: "忽略数据过滤",
            COL_DEPARTMENT: "部门",
            COL_USER_TYPE: "用户类型",

            USER_TYPE: {
                WAREHOUSE_STAFF: "仓库/办公室人员",
                AGENT_STAFF: "代理人员",
            },
        },
        ROLE: {
            LISTING_TITLE: "角色列表",
            CREATE_TITLE: "创建新角色",
            DETAIL_TITLE: "角色详情",
            EDIT_TITLE: "编辑角色详情",

            LBL_ROLE_NAME: "角色名称",
            LBL_ROLE_DESCRIPTION: "角色描述",
            LBL_ROLE_PERMISSION_PRIVILEGE: "权限",
            LBL_ROLE_PERMISSION: "角色权限",
            LBL_DEFAULT_SORT: "默认排序",
            LBL_SORT_ALPHABET: "按字母排序",
            LBL_SEARCH_PERMISSION: "搜索权限",
            LBL_ALL_PERMISSION: "全部权限",
            LBL_APPLY_TO: "适用于",

            MODULE_NAME: "角色",

            COL_NAME: "角色名称",
            COL_DESCRIPTION: "角色描述",
            COL_APPLY_TO: "适用于",

            WARNING_DUPLICATE:
                "提醒：此记录中存在数据 - {exist_record} <br /> 系统不允许您保存相同的数据记录。",
            BTN_SORT_MENU: "按目录排序",
            BTN_SORT_ALPHABET: "按字母排序",
            MSG_BLOCK_EDIT_CREATE_ROLE: "对于 {staff_type} 角色存在.",
        },
        DATA_FILTER: {
            LISTING_TITLE: "Data Filter Listing",
            CREATE_TITLE: "Create New Data Filter",
            DETAIL_TITLE: "Data Filter Detail",
            EDIT_TITLE: "Edit Data Filter Detail",

            LBL_DATA_FILTER_NAME: "Name",
            LBL_DATA_FILTER_DESCRIPTION: "Description",
            LBL_DATA_FILTER_COMPANY: "Company",
            LBL_DATA_FILTER_WAREHOUSE: "Warehouse",
            LBL_DATA_FILTER_MSM: "Main Salesman",
            LBL_DATA_FILTER_SM: "Salesman",
            LBL_DATA_FILTER_COUNTRY: "Country",
            LBL_DATA_FILTER_AGENT: "Agent",
            LBL_DATA_FILTER_MARKING: "客户代号",
            LBL_DATA_FILTER_PERMISSION_PRIVILEGE: "Permission & Privilege",
            LBL_INCLUDE: "include",
            LBL_EXCLUDE: "exclude",

            MODULE_NAME: "Data Filter",

            COL_NAME: "Data Filter Name",
            COL_DESCRIPTION: "Data Filter Description",
        },
        USER_GROUP: {
            LISTING_TITLE: "User Group Summary",
            CREATE_TITLE: "Create New User Group",
            DETAIL_TITLE: "User Group Detail",
            EDIT_TITLE: "Edit User Group",
            MODULE_NAME: "User Group",

            LBL_GROUP_CODE: "Group Code",
            LBL_GROUP_NAME: "Group Name",
            LBL_SPECIAL_RIGHTS: "Special Rights",
            LBL_SEARCH_SPECIAL_RIGHTS: "Search Special Rights",
        },
    },
    WMS: {
        MISSING_STATUS_INQUIRY: {
            LISTING_TITLE: "处理缺失订单",
            MODULE_NAME: "处理缺失订单",
            SHARED_SO: "共单号",
            SHARED_SO_TITLE: "共单",
            COL_COMPLETE_STATUS_INQUIRY: "未完整",
            COURIER_COMPANY_NAME: "快递公司",
            LBL_COURIER_COMPANY: "快递公司",
            CONSIGNMENT_NOTE_NO: "运单号码",
            WAREHOUSE_LOCATION: "仓库位置",
            FILL_IN_STATUS_INQUIRY: "处理订单",
            FILL_IN_STATUS_INQUIRY_TITLE: "处理订单",
            NOT_SAME_AS_EPO: "{name} 与EPO不同",
            FILL_IN_STATUS_INQUIRY_SUCCESS: "成功处理缺失订单",
            STATUS_INQUIRY_TYPE: "收货咨询种类",
            COURIER_STATUS_INQUIRY: "快递收货咨询",
            STATUS_INQUIRY: "收货咨询",
            MSG: {
                SEARCH_MISSING_SO_FAILED: "搜索缺失订单失败",
                UPDATE_DETAILS_CONFIRMATION:
                    "订单号的客户代号和送货地址不同。确定要更换吗？",
                SPECIAL_INS_FAILED: "未获得指示。",
            },
            CONFIRMATION_CONTINUE_RECEIVE:
                "Epo:{epo_no}请求停止接收<br/>您确定要继续接收吗？",
            INSTRUCTION_BY_MARKING: "客户指示",
            INSTRUCTION_BY_SO: "订单指示",
            ARRANGED_SO: "排单",
            EXCLUDE_ARRANGED_SO: "排除已排单",
            LBL_ASSIGNED_STATUS: "处理缺失订单",
            ASSIGNED_STATUS: {
                NOT_ASSIGNED: "未处理",
                ASSIGNED: "已处理",
            },
            NO_MARKING: "无客户代号",
            LBL_AUTO_SAVE_CONSIGNMENT_SO: "保存为快递订单",
            MSG_NOT_SAME_DETAILS: "{name} different then entered",
        },
        DUPLICATE_SO: {
            SUPPLIER_NAME: "Supplier Name",
            RECEIVED_DATE: "Received Date",
            SHARED_SO: "Shared S/O No.",
            CONFIRMATION_DUPLICATE_SO_NO:
                "Inbound with same So No exists.<br />Are You Sure to continue receiving?",
            MSG: {
                DUPLICATE_SO_NO: "Duplicate S/O No.",
            },
        },
        VERSION: "Version",
        CTN: "件数",
    },
    SETTINGS: {
        LANGUAGE: {
            CREATE_TITLE: "新建语言",
            LISTING_TITLE: "语言列表",
            DETAIL_TITLE: "语言详情",
            EDIT_TITLE: "编辑语言",
            MODULE_NAME: "语言",
            LBL_CODE: "语言编码",
            LBL_NAME: "语言名",
            LBL_LOCALE: "Locale",
            LBL_SUPPORT_AT: "支持于",
            LBL_SORT_ORDER: "排序顺序",
            LBL_IMAGE: "图片",

            COL_CODE: "语言编码",
            COL_NAME: "语言名",
            COL_SUPPORT_AT: "支持于",
            COL_SORT_ORDER: "顺序",
            COL_FLAG: "旗帜",
        },
        WAREHOUSE_SETTINGS: {
            LISTING_TITLE: "Warehouse Settings Summary",
            DETAIL_TITLE: "{warehouse_name} Warehouse Settings",
            GIMWORLD_SETTINGS: "GIM WORLD ORDER",
            MANIFEST_CONSIGNMENT_SETTING: "MANIFEST CONSIGNMENT SETTING",
            LBL_MANIFEST_ADDRESS: "Manifest Address",
            LBL_MANIFEST_CONTACT: "Manifest Contact No.",
            LBL_MANIFEST_NAME: "Manifest Name",
            GRN_FORMAT_SETTINGS: "GRN Format Settings",
            PN_FORMAT_SETTINGS: "PN Format Settings",
            MODULE_NAME: "Warehouse Settings",
            PREVIEW_GRN_FORMAT: "Preview GRN Format",

            LBL_WAREHOUSE: "Warehouse",
            LBL_CONTACT: "Contact Person",
            LBL_COMPANY: "Supported Company",
            LBL_QUOTATION_DESC: "Quotation Desc",

            LBL_GOODS_RECEIPT_PAYABLE_STICKER_FEE_CURRENCY:
                "Goods Received/Payable Note Sticker Fee Currency",
            LBL_GOODS_RECEIPT_PAYABLE_STICKER_FEE:
                "Goods Received/Payable Note Sticker Fee",
            LBL_QUOTE_AREA: "Replace {area} with State & City",
            LBL_WAREHOUSE_NAME_PRINT_IN_EPO: "Warehouse Name Print on EPO",
            LBL_FORWARDER: "Forwarder",
            LBL_FORWARDER_COUNTRY_ID: "Forwarder Country ID",
            LBL_FORWARDER_STATE_ID: "Forwarder State ID",

            LBL_GIMWORLD_ORDER_CATEGORY: "Default Category",
            LBL_SERVICE_CHARGES: "Default Service Charges",
            LBL_GIMWORLD_ORDER_CURRENCY: "Default Currency",
            LBL_GIMWORLD_ORDER_LOCATION: "Drop At",
            LBL_GIMWORLD_SUPPLIER: "Supplier",

            LBL_TT_CURRENCIES: "TT Currencies",
            LBL_DEFAULT_TT_CURRENCY: "Default TT Currency",

            GRN_FORMAT: {
                LBL_GRN_FORMAT: "GRN Format",
                LBL_COMPANY_HEADER_TITLE: "Company Title",
                LBL_GRN_TITLE: "GRN Title",
                LBL_COMPANY_ADDRESS_CONTACT: "Company Address & Contact No.",
                LBL_COMPANY_ADDRESS_CONTACT_RECEIPT:
                    "Company Address & Contact No. (Receipt)",
                LBL_GRN_REMARK: "GRN Remark",
                LBL_GRN_FOOTER_REMARK: "GRN Footer Remark",
                LBL_PRINT_GRN_FOOTER: "Print On Receipt Paper",
                LBL_PIC: "GRN Contact Persion",
                LBL_CALLING_CODE: "GRN Contact Calling Code",
                LBL_CONTACT: "GRN Contact No.",
            },

            PN_FORMAT: {
                LBL_COMPANY_HEADER_TITLE: "Company Title",
                LBL_COMPANY_ADDRESS_CONTACT: "Company Address & Contact No.",

                LBL_PIC: "PN Contact Persion",
                LBL_CALLING_CODE: "PN Contact Calling Code",
                LBL_CONTACT: "PN Contact No.",
            },

            COL_PIC: "Person In Charge",
            COL_CONTACT_NUMBER: "Contact Number",
            COL_WECHAT_ID: "WeChat ID",
            COL_IS_DEFAULT: "Default",
            COL_IS_SHOW: "Show",
            COL_REMARK: "Remark",
            COL_CONTACT_CALLING_CODE: "Contact Number Calling Code",
            COL_GIMWORLD_ORDER_CATEGORY: "GimWorld Order Default Category",

            LBL_EPO_WAREHOUSE_CONTACT_REMARK: "EPO Warehouse Contact Remark",

            COL_SUPPORTED_COM: "Supported Company",
            COL_STICKER_FEE: "Sticker Fee",

            TAB_TITLE: {
                GENERAL: "General",
                ORDER_RECEIVE: "Order Receive",
                QUOTATION_EPO: "Quotation & Epo",
            },

            MSG_COMPANY_CODE_NOT_SET: "Company Record not found",
        },
        SYS_NOTIFICATION: {
            MODULE_NAME: "系统通知设置",
        },
        AGENT: {
            MODULE_NAME: "Gbizs代理",
        },
    },
    TRANSACTION: {
        CONSIGNMENT_SO: {
            MODULE_NAME: "快递订单",
            SO_STATUS_DESC: "S/O发货细节还在等待客户确认您可以将其指定为待定",
            EPO_SELECTION_TITLE: "EPO Selection",
            DETAILS_TITLE: "快递细节",
            DETAILS_TITLE_SO: "{so_no} 快递细节",
            STATUS_INQ_MATCHED:
                "发现 S/O No.: {so_no}已被多次收到，请选择一个特定的条目.",

            LBL_TTL_RCV: "Ttl Rcv?",
            LBL_FULLY_RCV: "Fully Rcv?",
            LBL_ARRANGE_SO: "已排 S/O?",
            LBL_SO_STATUS: "S/O 状态",
            LBL_SUPPLIER: "供应商",
            LBL_ORDER_IMAGE: "上传 S/O",
            LBL_GRN_NO: "GRN No.",
            LBL_OTHER_COURIER_COMPANY: "其他快递公司",
            LBL_RECEIVED_CTN: "收到 CTN",
            LBL_COURIER: "快递公司?",
            LBL_SHARED_SO: "共享 S/O?",

            BTN_VIEW_DETAIL: "查看详情",
            BTN_ADD_EPO: "从EPO添加",
            BTN_ADD_SUPPLIER: "添加新客户的供应商",

            MSG_NO_EPO_SELECT: "请选择EPO",

            COL_COURIER_COMPANY: "快递公司",
            COL_CONSIGNMENT_NOTE_NO: "快递号.",
            COL_COURIER_LOGISTIC: "快递/物流",
            COL_ATTACHMENT: "附件",
            COL_IS_DELETED: "已删除",

            MSG_CONSIGNMENT_NO:
                "货物 ({consignment_no}) 似乎与另一个S/O重复。你确定要继续吗?",
            MSG_CONSIGNMENT_AUTO_SAVE:
                "快递 {consignment_no} 已经过状态查询并已成功匹配。您要保存此信息吗?",
            MSG_SO_NO_DUPLICATE_SHARE_SO: "Entered Shared S/O duplicate with S/O No.",
            MSG_SHARED_SO_DUPLICATE:
                "Entered Shared S/O No. duplicate with other Shared S/O No.",
            INBOUND_EXISTS: "存在收货咨询。",
        },
        QUOTATION: {
            MSG: {
                SEND_EMAIL: "通过邮件发送报价单",
                QUOTATION_CONTENT_UNDEFINED: "报价单内容不见。",
            },
        },
    },
    SEND_EMAIL: {
        LBL_TO: "To",
        LBL_CC: "CC",
        LBL_BCC: "BCC",
        LBL_SUBJECT: "Subject",
        LBL_CONTENT: "Content",
    },
    SCAN_DEVICE: {
        MSG_FAILED_INIT_SCAN_DEVICE: "❌ 扫描器初始化失败。",
        MSG_CAMERA_NOT_DETECT: "未检测到摄像头，请检查设备权限。",
        MSG_DEVICE_PERMISSION: "摄像头权限被拒绝，请在浏览器设置中允许访问摄像头",
        MSG_DEVICE_NOT_FOUND: "未找到摄像头设备，请检查连接",
        MSG_SCAN_ERROR: "启动摄像头失败:",
        MSG_UNKNOW_ERROR: "未知错误",
        MSG_SCANNING_PROGRESS: "⚠️ 扫描已在进行中。",
        MSG_NOT_READABLE: "摄像头被其他应用占用。",
        MSG_CAMERA_OVER_CONSTRAINED: "摄像头配置不满足要求。",
        MSG_TIMEOUT: "启动超时，请重试",
        MSG_OUT_OF_MEMORY: "设备内存不足，请关闭其他应用后重试",
        MSG_MAX_RECOVERY: "多次尝试失败，请重启浏览器",
        MSG_START_UP_FAILED: "启动失败",
        MSG_FAILED_START_UP_RESTART: "摄像头无法启动，请使用图片扫码或重启浏览器",
        MSG_DECODE_FAILED: "解码失败",
        MSG_INVALID_IMAGE: "请确保图片包含有效的二维码/条码",
        MSG_PERMISSION_REQUIRED: "需要摄像头权限",
        MSG_AUTHORIZE_CAMERA: "点击「授权」以允许访问摄像头",
        MSG_INITIALIZING_CAMERA: "摄像头启动中。。。 。。。",

        BTN_AUTHORIZE: "授权",
    },
};
